import { useState } from 'react';

import { FileDown } from 'lucide-react';

import Button from '../../common/Button';
import { type TypeDataset, type TypeIFS } from '../../common/dataTypes';
import useConverter from '../../hooks/tanstack/useConverter';

import DownloadTemplatesDialog from './DownloadTemplatesDialog';

type DownloadIFSTemplatesDialogProps = {
  dataset?: TypeDataset;
  ifs: TypeIFS;
  trigger?: {
    label?: React.ReactNode;
    style?: React.CSSProperties;
  };
};

const DownloadIFSTemplatesDialog = ({
  ifs,
  dataset,
}: DownloadIFSTemplatesDialogProps) => {
  const { saveIfsAsZip } = useConverter();

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDownloadAll = () => {
    if (!ifs) {
      alert(
        'This dataset has no configuration, please add configuration first.'
      );
      return;
    }

    saveIfsAsZip(ifs, dataset?.name ?? 'File');
    handleClose();
  };

  const handleDownloadOne = (file: TypeIFS['files'][number]) => {
    saveIfsAsZip(
      {
        ...ifs,
        files: [file],
      },
      dataset?.name ?? 'File'
    );
  };

  return (
    <DownloadTemplatesDialog
      open={open}
      handleOpen={handleOpen}
      handleClose={handleClose}
    >
      <>
        <div className="flex items-center justify-between">
          <h1 className="text-xl font-semibold">Download Template(s)</h1>
          <Button onClick={handleDownloadAll} variant="outlined_blue">
            <FileDown size={20} />
            Download all
          </Button>
        </div>
        <div className="flex flex-col gap-4">
          <p className="font-bold text-[#666666]">Name</p>
          {ifs.files?.map((file, index) => (
            <div key={index} className="flex justify-between">
              <p className="w-[500px] truncate">
                {file.name.replace(file.name.split('.')[1], '')}
              </p>
              <button
                onClick={() => {
                  handleDownloadOne(file);
                }}
                className="cursor-pointer"
              >
                <FileDown size={20} color="#2196F3" />
              </button>
            </div>
          ))}
        </div>
      </>
    </DownloadTemplatesDialog>
  );
};

export default DownloadIFSTemplatesDialog;
